import { useCallback, useEffect, useState } from "react";

const KEY = "moin-favorites";
const EVT = "moin-favorites-change";

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
};

export function useFavorites() {
  const [ids, setIds] = useState(read);
  useEffect(() => {
    const sync = () => setIds(read());
    window.addEventListener(EVT, sync);
    window.addEventListener("storage", sync);
    return () => { window.removeEventListener(EVT, sync); window.removeEventListener("storage", sync); };
  }, []);
  const toggle = useCallback((id) => {
    const cur = read();
    const next = cur.includes(id) ? cur.filter((x) => x !== id) : [...cur, id];
    localStorage.setItem(KEY, JSON.stringify(next));
    window.dispatchEvent(new Event(EVT));
    return next.includes(id);
  }, []);
  const prune = useCallback((keep) => {
    localStorage.setItem(KEY, JSON.stringify(read().filter((x) => keep.includes(x))));
    window.dispatchEvent(new Event(EVT));
  }, []);
  return { ids, has: (id) => ids.includes(id), toggle, prune };
}
